(() => {
  // --- helpers ---
  const qs = (root, sel) => root.querySelector(sel);
  const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

  function parseCounter(counterEl) {
    const currentEl = qs(counterEl, ".slider-counter--current");
    const totalEl = qs(counterEl, ".slider-counter--total");

    if (currentEl && totalEl) {
      const current = parseInt(currentEl.textContent.trim(), 10) || 1;
      const total = parseInt(totalEl.textContent.trim(), 10) || 1;
      return { current, total, currentEl };
    }

    // Fallback: "2 / 4"
    const txt = counterEl.textContent.replace(/\s+/g, " ").trim();
    const m = txt.match(/(\d+)\s*\/\s*(\d+)/);
    const current = m ? parseInt(m[1], 10) : 1;
    const total = m ? parseInt(m[2], 10) : 1;
    return { current, total, currentEl: counterEl };
  }

  function isFeaturedCollectionSection(section) {
    // Covers Dawn + many app wrappers:
    // - data-section-type="featured-collection"
    // - class includes "featured-collection"
    // - file/section name patterns
    const typeEl = section.matches?.('[data-section-type="featured-collection"]')
      ? section
      : qs(section, '[data-section-type="featured-collection"]');

    if (typeEl) return true;

    const cls = (section.className || "").toLowerCase();
    if (cls.includes("featured-collection")) return true;

    // Shopify section wrappers often have ID like shopify-section-template--...__featured_collection_...
    const id = (section.id || "").toLowerCase();
    if (id.includes("featured") && id.includes("collection")) return true;

    return false;
  }

  function buildDotsForSection(section) {
    // Find the counter within this section
    const counter = qs(section, ".slider-counter");
    if (!counter) return;

    // Only apply to Featured Collection sections
    const shopifySection = counter.closest(".shopify-section, section") || section;
    if (!isFeaturedCollectionSection(shopifySection)) return;

    // Find buttons (Dawn uses name="previous"/"next")
    const buttonsWrap = counter.closest(".slider-buttons") || qs(shopifySection, ".slider-buttons");
    if (!buttonsWrap) return;

    const prevBtn = qs(buttonsWrap, 'button[name="previous"], button.slider-button--prev');
    const nextBtn = qs(buttonsWrap, 'button[name="next"], button.slider-button--next');
    if (!prevBtn || !nextBtn) return;

    // Mark section so CSS can target it safely
    shopifySection.classList.add("fc-dots");

    // Force-hide numeric counter text inline (bypasses CSS selector mismatches)
    counter.style.fontSize = "0";
    counter.style.lineHeight = "0";

    // Remove existing dots if we rebuild
    qsa(buttonsWrap, ".slider-dots").forEach((el) => el.remove());

    const { total } = parseCounter(counter);

    // Create dots
    const dotsWrap = document.createElement("div");
    dotsWrap.className = "slider-dots";
    dotsWrap.setAttribute("aria-label", "Slider pagination");
    dotsWrap.setAttribute("role", "tablist");

    for (let i = 1; i <= total; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "slider-dot";
      dot.dataset.index = String(i);
      dot.setAttribute("role", "tab");
      dot.setAttribute("aria-label", `Go to slide ${i} of ${total}`);

      dot.addEventListener("click", () => {
        const { current } = parseCounter(counter);
        const diff = i - current;
        if (diff === 0) return;

        const btn = diff > 0 ? nextBtn : prevBtn;
        let steps = Math.abs(diff);

        // Click through using Dawn’s own buttons (stable)
        const timer = setInterval(() => {
          btn.click();
          steps -= 1;
          if (steps <= 0) clearInterval(timer);
        }, 220);
      });

      dotsWrap.appendChild(dot);
    }

    // Insert dots right after the counter (matches where your numbers currently sit)
    counter.insertAdjacentElement("afterend", dotsWrap);

    const sync = () => {
      const { current } = parseCounter(counter);
      qsa(dotsWrap, ".slider-dot").forEach((d) => {
        const idx = parseInt(d.dataset.index, 10);
        if (idx === current) d.setAttribute("aria-current", "true");
        else d.removeAttribute("aria-current");
      });
    };

    sync();

    // Observe changes to keep dots in sync when Dawn updates the counter
    const { currentEl } = parseCounter(counter);
    const target = currentEl || counter;

    const mo = new MutationObserver(() => sync());
    mo.observe(target, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    // Find all counters on the page; filter down to Featured Collection sections
    document.querySelectorAll(".slider-counter").forEach((counter) => {
      const section = counter.closest(".shopify-section, section") || document.body;
      buildDotsForSection(section);
    });
  }

  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
})();
